import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  center_Id: null,
  center_Name: null,
  center_Desc: null,
  center_Logo_URL: null,
  country_Desc: 'USA',
  organization_Id: 0,
  app_Id: 1,
};

const centerSlice = createSlice({
  name: 'center',
  initialState,
  reducers: {
    // Set center data
    setCenter: (state, action) => {
      const { center_Id, center_Name, center_Desc, center_Logo_URL, country_Desc } = action.payload;
      state.center_Id = center_Id;
      state.center_Name = center_Name;
      state.center_Desc = center_Desc;
      state.center_Logo_URL = center_Logo_URL;
      if (country_Desc) {
        state.country_Desc = country_Desc;
      }
    },

    // Set country
    setCountry: (state, action) => {
      state.country_Desc = action.payload;
    },

    // Set organization ID
    setOrganizationId: (state, action) => {
      state.organization_Id = action.payload;
    },

    // Set app ID
    setAppId: (state, action) => {
      state.app_Id = action.payload;
    },

    // Clear center data
    clearCenter: (state) => {
      state.center_Id = null;
      state.center_Name = null;
      state.center_Desc = null;
      state.center_Logo_URL = null;
      state.country_Desc = 'USA';
      state.organization_Id = 0;
      state.app_Id = 1;
    },
  },
});

export const { setCenter, setCountry, setOrganizationId, setAppId, clearCenter } = centerSlice.actions;
export default centerSlice.reducer;
